import React from "react";
import { Link } from 'react-router-dom';

export default function PlusLoinVendeur(args) {

    return (
        <>
            <blockquote className="blog-quote">
                <b>Pour aller plus loin sur la vente immobiliere chez le notaire :</b><br />
                <Link to="/immobilier/notaire/compromis-de-vente">Tout savoir sur le compromis de vente chez le notaire</Link><br/>
                <Link to="/immobilier/notaire/documents-vente-notaire" >Quels sont les documents de vente à fournir au notaire pour la vente d'un bien immobilier ?</Link><br />
                <Link to="/immobilier/notaire/frais-vente-notaire">Quels sont les frais de notaire pour la vente d'un bien immobilier ?</Link><br />
                <Link to="/immobilier/notaire/role-notaire-vente-immobilier">Quel est le rôle du notaire dans la vente d'un bien immobilier ?</Link>
            </blockquote>
        </>
    );
}
